import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaVehiculoSelectInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculoSelect.interface";
import apiClient from "@/clients/apiClient";

export async function FindAllSelectAction(): Promise<
  ApiResponse<MarcaVehiculoSelectInterface>
> {
  const { data } = await apiClient.get<MarcaVehiculoSelectInterface>(
    "/gvMarcaVehiculos/select"
  );
  return {
    status: 200,
    data,
    message: "Marca de vehiculos obtenidas correctamente",
  };
}
